module.exports = "pegasus/assets/column-14-basic.png";